import { Alert, Spin } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { FC, ReactNode } from "react";

interface QueryStateProps {
    isLoading: boolean;
    isError: boolean;
    errorMessage?: string;
    errorKey?: string;
    children?: ReactNode;
}

/**
 * Renders a loading spinner or error alert based on query state.
 * Returns children (or null) when neither loading nor error.
 *
 * Use `errorKey` for translated common error keys (e.g. "errors.loading_integration"),
 * or `errorMessage` for raw strings. Falls back to "errors.something_went_wrong".
 */
export const QueryState: FC<QueryStateProps> = ({ isLoading, isError, errorMessage, errorKey, children = null }) => {
    const { t: tC } = usePaldockTranslation("common");

    if (isError) {
        const message = errorMessage ?? (errorKey ? tC(errorKey) : tC("errors.something_went_wrong"));
        return (
            <div className="flex justify-center items-center p-8">
                <Alert type="error" message={message} />
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="flex justify-center items-center p-8">
                <Spin />
            </div>
        );
    }

    return <>{children}</>;
};
